import React from "react";
import filter from "../assets/images/filter.png";
import exportPic from "../assets/images/export.png";
import moneyDoller from "../assets/images/money-dollar.png";

const PaymentMangement = () => {
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="FilterArea mt-0">
            <div className="FilterLeft">
              <div className="form-group">
                <label>From Date</label>
                <input type="date" className="form-control" />
              </div>
              <div className="form-group">
                <label>To Date</label>
                <input type="date" className="form-control" />
              </div>
              <div className="form-group">
                <label>&nbsp;</label>
                <button className="Button">Apply</button>
              </div>
              <div className="form-group">
                <label>Timeframe</label>
                <select className="form-control">
                  <option>Select </option>
                  <option value="Today">Today</option>
                  <option value="Week">This Week</option>
                  <option value="Month">This Month</option>
                </select>
              </div>
            </div>
            <div className="FilterRight"></div>
          </div>
          <div className="DashboardBoxSecond">
            <ul>
              <li>
                <article>
                  <aside>
                    <p>Total Courses Purchased</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDoller} />
                    </span>
                    <figcaption>
                      <h3>100</h3>
                    </figcaption>
                  </aside>
                </article>
              </li>
              <li>
                <article>
                  <aside>
                    <p>Total Revenue (in $)</p>
                  </aside>
                  <aside>
                    <span className="Icon Orange">
                      <img src={moneyDoller} />
                    </span>
                    <figcaption>
                      <h3>10000</h3>
                    </figcaption>
                  </aside>
                </article>
              </li>
            </ul>
          </div>
          <div className="NewFilter">
            <div className="SearchBox">
              <input
                type="search"
                className="SearchInput"
                placeholder="Search here by ID, Name, or Others"
              />
              <span>
                <i className="fa fa-search" />
              </span>
            </div>
            <div className="Actions">
              <button className="FilterBtn">
                <span>
                  <img src={filter} />
                </span>
                Filters
              </button>
              <button className="ExportBtn">
                <span>
                  <img src={exportPic} />
                </span>
                Export
              </button>
            </div>
          </div>
          <div className="TableList">
            <table className="table-hover">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Transaction Id</th>
                  <th>Transaction Date &amp; Time</th>
                  <th>Student Id</th>
                  <th>Student Name</th>
                  <th>Course Id</th>
                  <th>Course Name</th>
                  <th>Amount (in $)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>01</td>
                  <td>T-141</td>
                  <td>25/05/2024, 09:00 AM</td>
                  <td>S-141</td>
                  <td>John</td>
                  <td>S-101</td>
                  <td>Begin Python</td>
                  <td>50</td>
                </tr>
                <tr>
                  <td>02</td>
                  <td>T-141</td>
                  <td>25/05/2024, 09:00 AM</td>
                  <td>S-141</td>
                  <td>John</td>
                  <td>S-101</td>
                  <td>Begin Python</td>
                  <td>50</td>
                </tr>
                <tr>
                  <td>03</td>
                  <td>T-141</td>
                  <td>25/05/2024, 09:00 AM</td>
                  <td>S-141</td>
                  <td>John</td>
                  <td>S-101</td>
                  <td>Begin Python</td>
                  <td>50</td>
                </tr>
                <tr>
                  <td>04</td>
                  <td>T-141</td>
                  <td>25/05/2024, 09:00 AM</td>
                  <td>S-141</td>
                  <td>John</td>
                  <td>S-101</td>
                  <td>Begin Python</td>
                  <td>50</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Pagination">
            <p>Showing 1 to 10 of 97 results</p>
            <ul>
              <li>
                <a href="javascript:void(0);">
                  <i className="fa fa-angle-left" />
                </a>
              </li>
              <li>
                <a href="javascript:void(0);">1</a>
              </li>
              <li className="active">
                <a href="javascript:void(0);">2</a>
              </li>
              <li>
                <a href="javascript:void(0);">3</a>
              </li>
              <li>
                <a href="javascript:void(0);">4</a>
              </li>
              <li>
                <a href="javascript:void(0);">...</a>
              </li>
              <li>
                <a href="javascript:void(0);">20</a>
              </li>
              <li>
                <a href="javascript:void(0);">21</a>
              </li>
              <li>
                <a href="javascript:void(0);">
                  <i className="fa fa-angle-right" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMangement;
